<template>
  <div class="about">
    <h1 class="title">What is NYC?</h1>
    <p>なりさわゆうのサイトへようこそ^^</p>
    <p>作ったものや描いたものを載せる場所です。</p>
    <p>フロントエンド開発の練習をしながら作っています（開発中）。</p>
  </div>
</template>

<style scoped>
.title {
  padding-bottom: 50px;
}
</style>
